import {Injectable} from '@angular/core';

import {ConfigSystem} from '../static/config-system';
import {BaseService} from './base.service';
import {AuthService} from './auth.service';

@Injectable()
export class ConfigSystemService {

    path = '/config';

    constructor(private baseService: BaseService, private authService: AuthService) {
        //tenta buscar config apenas se já estiver logado
        this.authService.isLoggedIn$.subscribe(isLoggedIn => {
            if(isLoggedIn){
                this.baseService.get(this.path, '/').subscribe((configs: { type: string, value: string }[]) => {
                    configs.forEach(config => {
                        //if (config.type === 'param_by') ConfigSystem.param_by = config.value;
                    });
                    // console.log('ConfigSystem: ', ConfigSystem);
                });
            }
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/config-system.service.ts